/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export let ComHubspotContentstagingRpcErrorCreateStagedPageErrorIF;
(function (_ComHubspotContentstagingRpcErrorCreateStagedPageErrorIF) {})(ComHubspotContentstagingRpcErrorCreateStagedPageErrorIF || (ComHubspotContentstagingRpcErrorCreateStagedPageErrorIF = {}));
export let ComHubspotContentstagingRpcErrorStagedPageErrorIF;
(function (_ComHubspotContentstagingRpcErrorStagedPageErrorIF) {})(ComHubspotContentstagingRpcErrorStagedPageErrorIF || (ComHubspotContentstagingRpcErrorStagedPageErrorIF = {}));
export const getDraftPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getDraftPages',
  auth: 'app',
  fingerprint: 'dr-0BzQI0wtDKL9uFKnj9d4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProofPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getProofPages',
  auth: 'app',
  fingerprint: 'dr-0BzQI0wtDKL9uFKnj9d4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUnstagedPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getUnstagedPages',
  auth: 'app',
  fingerprint: 'qDr9ONFOj_syduYMx3lqRd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageCountsRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getPageCounts',
  auth: 'app',
  fingerprint: 'iu0k_Lz5hSbkdCJT0BI0kd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStagedPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getStagedPage',
  auth: 'app',
  fingerprint: '9ULFmOPwrw8y8-0IDaLacN4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStagedPageContentRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'getStagedPageContent',
  auth: 'app',
  fingerprint: 'Imhqp00mIX3kYzceU0WCL94p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const stageExistingPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'stageExistingPage',
  auth: 'app',
  fingerprint: 'UvtL2-sPfcQy8-0IDaLacLci-1HYRmSq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const stageNewPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'stageNewPage',
  auth: 'app',
  fingerprint: 'nnoAUiC8oC0y8-0IDaLacLci-1HYRmSq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneStagedPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'cloneStagedPage',
  auth: 'app',
  fingerprint: 'gt6qTyzzvw4y8-0IDaLacLci-1HYRmSq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const autoSaveStagedPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'autoSaveStagedPage',
  auth: 'app',
  fingerprint: 'jf5mCTgky8Ey8-0IDaLacN4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const manualSaveStagedPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'manualSaveStagedPage',
  auth: 'app',
  fingerprint: 'jf5mCTgky8Ey8-0IDaLacN4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const proofPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'proofPage',
  auth: 'app',
  fingerprint: 'tlp3SA2BROWOUe2e_r4Xmd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unproofPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'unproofPage',
  auth: 'app',
  fingerprint: 'eOR6LFHLTP-OUe2e_r4Xmd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkProofPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'bulkProofPages',
  auth: 'app',
  fingerprint: 'BJ7qdE-cs8wVvzYo_2UIXd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUnproofPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'bulkUnproofPages',
  auth: 'app',
  fingerprint: 'YmvA2Cxh-HIWU3cKFO6EXd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkDeleteStagedPagesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'bulkDeleteStagedPages',
  auth: 'app',
  fingerprint: 's5gBceaPa3WP-H4ccpTdQd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteStagedPageRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPagesRpc',
  rpcName: 'deleteStagedPage',
  auth: 'app',
  fingerprint: 'ppDBY5qGMIsJBdM38nGYyt4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};